


































































































import { Component, Vue } from "vue-property-decorator";
import { BIcon, BIconBoxArrowRight } from "bootstrap-vue";

@Component({
  components: {
    BIcon,
    BIconBoxArrowRight,
  },
})
export default class DefDef extends Vue {}
